import { Provider } from 'react-redux';
import './App.css';
import MainNavigation from './router';
import { store } from './store';

function App() {
  return (
    <Provider store={store}>
      <MainNavigation />
    </Provider>
  );
}

export default App;
